export default {"src":"/_next/static/media/sign-in-bold.33999037.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};